import { FormikProps } from 'formik';
import React from 'react';
import { useSelector } from 'react-redux';
import { FormField } from '../../../../../global/components/form-element/form-field';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { FormGroup } from '../../../../../global/components/layout/form-group';
import { parseLov } from '../../../../../global/helpers/form-data-helper';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { NewHireProps } from '../../../models/arc-epi-props';
import { NewHireFormValues } from '../models/new-hire-form-model';

interface Props {
    formProps: FormikProps<NewHireFormValues>;
    newHireProps: NewHireProps;
}
export function NewHireNonStipPositionFields(props: Props) {
    const { formProps, newHireProps } = props;

    const positionTitles = useSelector<TcsmStates, any>(state => state.lovProcState?.personLov?.position_title);
    const positionTitleOptions = positionTitles ? parseLov(positionTitles, true) : [];

    return (
        <DividerSection sectionText={newHireProps?.addPositionHeader} removeDivider>
            <FormGroup>
                <FormField
                    name='start_date'
                    label={newHireProps?.nonStipStartDateLabel}
                    component='datePicker'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    tooltip={{ title: newHireProps?.nonStipStartDateTooltip }}
                    required
                    autoWidth
                />
                <FormField
                    name='end_date'
                    label={newHireProps?.nonStipTerminationDateLabel}
                    component='datePicker'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    tooltip={{ title: newHireProps?.nonStipTerminationDateTooltip }}                  
                    autoWidth
                />
                
                <FormField
                    name='position_title'
                    options={positionTitleOptions}
                    label={newHireProps?.positionTitleLabel}
                    component='input'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    tooltip={{ title: newHireProps?.positionTitleTooltip }}
                    select
                    required
                />

                <FormField
                    name='position_start_date'
                    label={newHireProps?.positionStartDateLabel}
                    component='datePicker'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    required
                    autoWidth
                />

                <FormField
                    name='position_end_date'
                    label={newHireProps?.positionEndDateLabel}
                    component='datePicker'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    autoWidth
                />

                <FormField
                    name='published_title'
                    label={newHireProps?.publishedTitleLabel}
                    component='input'
                    touched={formProps.touched}
                    errors={formProps.errors}
                    tooltip={{ title: newHireProps?.publishedTitleTooltip }}
                />
            </FormGroup>
        </DividerSection>
    );
}